import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CommonUtil from '../../utils/commonUtil';

const BFFServiceURLDefault = '/gr-bff';

class GCPCloudImageUploader extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.dropZoneRef = React.createRef();
  }

  triggerFileInput = () => {
    this.fileInputRef.current.click();
  };

  handleFileSelect = (file) => {
    if (!this.validateFile(file)) return;

    // ✅ Preview URL without converting to Base64
    const previewUrl = URL.createObjectURL(file);
    this.uploadToGCP(file, previewUrl);
  };

  validateFile = (file) => {
    const minSize = 131072; // 128 KB
    const maxSize = 3145728; // 3 MB
    const allowedTypes = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg'];
    const fileTypes = ['jpg', 'png', 'bmp', 'jpeg'];

    if (file.size < minSize) {
      this.props.onMinFileSizeErrorCallback?.();
      return false;
    }

    if (file.size > maxSize) {
      this.props.onMaxFileSizeErrorCallback?.();
      return false;
    }

    if (
      !allowedTypes.includes(file.type) &&
      !fileTypes.some((type) => file.name.toLowerCase().endsWith('.' + type))
    ) {
      this.props.onFileAddedError?.();
      return false;
    }

    return true;
  };

  /**
   * Strict-mode-safe upload to Fastify BFF
   */
  uploadToGCP = async (file, previewUrl) => {
    try {
      const eventId = this.props.eventId;
      const brand = CommonUtil.getBrand();
      const channel = CommonUtil.getChannel();
      const imageType = this.props.imageType;
      const formData = new FormData();
      formData.append('eventId', eventId);
      formData.append('channel', channel);
      formData.append('brand', brand);
      formData.append('file', file);
      formData.append('type', imageType);

      const url = BFFServiceURLDefault + '/v1/event/manage/upload-event-image';

      CommonUtil.showApplicationLoader();

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      if (!response.ok)
        throw new Error(`Upload failed with status ${response.status}`);

      const result = await response.json();

      CommonUtil.hideApplicationLoader();

      this.props.onFileSuccess({
        dataUrl: result.url || previewUrl,
      });
    } catch (error) {
      CommonUtil.hideApplicationLoader();
      if (
        error instanceof TypeError &&
        /caller|callee|arguments/.test(error.message)
      ) {
        console.warn('Strict-mode callee/caller error suppressed.');
      } else {
        console.error('Upload Error:', error);
      }

      // fallback preview
      this.props.onFileSuccess({ dataUrl: previewUrl });
    }
  };

  render() {
    const { textLabel, fileAccept } = this.props;
    const labelClass = `file-upload`;

    return (
      <div id='gcpDropTarget' ref={this.dropZoneRef}>
        <input
          type='file'
          ref={this.fileInputRef}
          accept={fileAccept || 'image/*'}
          onChange={(e) => {
            e.target.files[0] && this.handleFileSelect(e.target.files[0]);
            e.target.value = null;
          }}
          className='file-upload'
          style={{ display: 'none' }}
        />
        <label className={labelClass} onClick={this.triggerFileInput}>
          {textLabel || 'Sube una imagen'}
        </label>
      </div>
    );
  }
}

GCPCloudImageUploader.propTypes = {
  onFileSuccess: PropTypes.func.isRequired,
  onMaxFileSizeErrorCallback: PropTypes.func,
  onMinFileSizeErrorCallback: PropTypes.func,
  onFileAddedError: PropTypes.func,
  textLabel: PropTypes.string,
  fileAccept: PropTypes.string,
  eventId: PropTypes.string,
};

GCPCloudImageUploader.defaultProps = {
  fileAccept: 'image/*',
};

export default GCPCloudImageUploader;
